import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { ReactNode } from "react";

export interface Shortcut {
  id: string;
  visible: boolean;
  name: string;
  icon: ReactNode;
  group: string;
  href: string;
  isExternal?: boolean;
}

interface ShortcutMenuStore {
  isEditing: boolean;
  isMounted: boolean;
  shortcuts: Shortcut[];
  setIsEditing: (value: boolean) => void;
  setIsMounted: (value: boolean) => void;
  setShortcuts: (data: Shortcut[]) => void;
}

export const useShortcutMenuStore = create<ShortcutMenuStore>()(
  immer((set) => ({
    isEditing: false,
    isMounted: false,
    shortcuts: [],

    setIsEditing: (value) =>
      set((state) => {
        state.isEditing = value;
      }),

    setIsMounted: (value) =>
      set((state) => {
        state.isMounted = value;
      }),

    setShortcuts: (data) =>
      set((state) => {
        state.shortcuts = data;
      }),
  }))
);
